export class AddViewExhibitorInput {
    userGuid: string
    exhibitorId: number
}
